import callAPI from "../callApi";
import path from "../variables";

const VehiclePosition = {
	fleet: () =>
		callAPI("GET", `${path.base}/tracking/fleet`, "", "fetching fleet positions"),
	getToken: (vehicleId: number) =>
		callAPI("GET", `${path.base}/tracking/vehicles/${vehicleId}/token`, "", "getting tracking token"),
	// History of finished/cancelled embarkations whose GPS trail can be
	// replayed on the map. `params` mirrors the controller validation:
	// vehicle_id (number), from/to (YYYY-MM-DD), per_page (1..100).
	history: (params: Record<string, string | number | undefined> = {}) => {
		const qs = Object.entries(params)
			.filter(([_, v]) => v !== undefined && v !== null && v !== "")
			.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
			.join("&");
		const suffix = qs ? `?${qs}` : "";
		return callAPI("GET", `${path.base}/tracking/history`, suffix, "fetching tracking history");
	},
	trail: (embarkationId: number) =>
		callAPI(
			"GET",
			`${path.base}/tracking/embarkations/${embarkationId}/trail`,
			"",
			"fetching embarkation trail"
		),
};

export default VehiclePosition;
